import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Drawer,
} from "@mui/material";
import {
  Folder as FolderIcon,
  MoreVert as MoreVertIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import FilePreview from "../classification_component/FilePreview";

const drawerWidth = 280;

function AccreditationSidebar({
  accreditationAreas,
  expandedCategories,
  toggleCategoryExpansion,
  categoryFiles,
  deleteCategory,
  fileToDelete,
  setDeleteDialogOpen,
  setDeleteCategory,
  setFileToDelete,
  handleDeleteFile,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFile, setMenuFile] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  const handleMenuOpen = (event, file) => {
    setAnchorEl(event.currentTarget);
    setMenuFile(file);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuFile(null);
  };

  const handlePreview = () => {
    console.log("handlePreview activated...");
    setPreviewFile(menuFile);
    setPreviewOpen(true);
    handleMenuClose();
  };

  const handleDelete = () => {
    if (menuFile) {
      handleDeleteFile(menuFile.categoryId, menuFile.fileName || menuFile.name);
    }
    handleMenuClose();
  };

  const handlePreviewClose = () => {
    setPreviewOpen(false);
    setPreviewFile(null);
  };

  const drawerContent = (
    <Box
      sx={{
        width: drawerWidth,
        p: 2,
        overflow: "auto",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Accreditation Areas</Typography>
      </Box>

      <List sx={{ mb: 2 }}>
        {accreditationAreas.map((area) => (
          <React.Fragment key={area.id}>
            <ListItem
              button
              onClick={() => toggleCategoryExpansion(area.id)}
              sx={{
                bgcolor: "rgba(0, 0, 0, 0.04)",
                borderRadius: 1,
                mb: 1,
                width: "90%",
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 32, // Default is 56px, reduce to 32px or less
                  // Or use minWidth: 'auto' for minimal spacing
                }}
              >
                <FolderIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={area.name}
                sx={{
                  "& .MuiListItemText-primary": {
                    fontSize: 16,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                }}
              />
              {expandedCategories[area.id] ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </ListItem>
            {expandedCategories[area.id] && (
              <Box sx={{ pl: 1, mb: 1, pr: 2.5 }}>
                {categoryFiles &&
                categoryFiles[area.id] &&
                categoryFiles[area.id].length > 0 ? (
                  <List dense disablePadding>
                    {categoryFiles[area.id].map((file, index) => (
                      <ListItem
                        key={index}
                        secondaryAction={
                          <IconButton
                            edge="end"
                            aria-label="more-options"
                            onClick={(e) =>
                              handleMenuOpen(e, {
                                ...file,
                                fileName: file.fileName || file.name,
                                categoryId: area.id,
                              })
                            }
                            size="small"
                            sx={{
                              border: "1px solid",
                              borderRadius: 1,
                            }}
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        }
                      >
                        <ListItemIcon sx={{ minWidth: 20, mr: 1 }}>
                          <FolderIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Tooltip title={file.fileName || file.name}>
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  maxWidth: 120,
                                  paddingTop: 5,
                                }}
                              >
                                {file.fileName || file.name}
                              </span>
                            </Tooltip>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    No documents in this category
                  </Typography>
                )}
              </Box>
            )}
          </React.Fragment>
        ))}
      </List>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            maxHeight: 48 * 4.5,
            width: "12ch",
          },
        }}
      >
        <MenuItem onClick={handlePreview}>Preview</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>

      {previewFile && (
        <FilePreview
          open={previewOpen}
          onClose={handlePreviewClose}
          file={previewFile}
        />
      )}
    </Box>
  );

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          zIndex: 1000, // Lower than typical header z-index (1100-1300)
          marginTop: 9, // Adjust this to match your header height
        },
      }}
    >
      {drawerContent}
    </Drawer>
  );
}

export default AccreditationSidebar;
